<template>
    <ItemImageContent 
        v-if="$props.imageSrc"
        :imageSrc="$props.imageSrc"
        :imageAlt="$props.imageAlt"
        :imageClasses="$props.imageClasses"
    />
    <ItemTextContent
        :title="$props.title"
        :titleClasses="$props.titleClasses"
        :info="$props.info"
        :noInfo="$props.noInfo"
        :infoClasses="$props.infoClasses"
        :abstract="$props.abstract"
        :noAbstract="$props.noAbstract"        
        :abstractClasses="$props.abstractClasses"
    /> 
</template>

<script>
import ItemImageContent from './item-image-content'
import ItemTextContent from './item-text-content'

export default {
    components: {
        ItemImageContent,
        ItemTextContent
    },

    props: {
        title: { type: String, required: true},
        titleClasses: { type: String, default: ''},

        imageSrc: { type: String, required: true },        
        imageAlt: { type: String, default: '' },
        imageClasses: { type: String, default: '' },

        useFallbackImage : { type: Boolean, default: false},

        info: { type: String, default: ''},
        noInfo: { type: Boolean, default: false },
        infoClasses: { type: String, default: ''},

        abstract: { type: String, default: ''},
        noAbstract: { type: Boolean, default: false },
        abstractClasses: { type: String, default: ''},
    }  
}
</script>

<style lang="css" scoped>
</style>